<template>
  <div>
    <v-speed-dial
      v-model="fab"
      bottom
      right
      :transition="transition"
      fixed
      v-if="$vuetify.breakpoint.smAndDown"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" :color="color" dark fab>
          <v-icon v-if="fab"> mdi-close </v-icon>
          <v-icon v-else> mdi-plus </v-icon>
        </v-btn>
      </template>

      <div class="main-container">
        <template v-for="(option, i) in options">
          <div
            :key="i"
            class="btn-container"
            :class="{
              'no-margin': option.action === 'download' && showActions.download,
            }"
            :style="{ marginRight: downloadActionVisible ? '120px' : '80px' }"
            v-if="showActions[option.action]"
          >
            <v-btn class="main-text" @click="handleAction(option.action)">
              {{ option.name }}
            </v-btn>
            <v-btn fab dark small :color="color">
              <v-icon dense>{{ option.icon }}</v-icon>
            </v-btn>
          </div>
        </template>
      </div>
    </v-speed-dial>
  </div>
</template>

<script>
export default {
  props: {
    onAction: {
      type: Function,
      required: true,
    },
    showActions: {
      type: Object,
      default: () => ({
        add: true,
        print: true,
        download: true,
      }),
    },
  },
  data() {
    return {
      fab: false,
      transition: "slide-y-reverse-transition",
      color: "indigo darken-4",
      fav: true,
      menu: false,
      options: [
        {
          action: "print",
          icon: "mdi-printer",
          name: "Print",
        },
        {
          action: "download",
          icon: "mdi-download",
          name: "Download",
        },
        {
          action: "add",
          icon: "mdi-plus",
          name: "Add",
        },
      ],
    };
  },
  computed: {
    downloadActionVisible() {
      return this.showActions.download;
    },
  },

  methods: {
    handleAction(action) {
      this.onAction(action);
    },
  },
};
</script>

<style scoped>
.main-container {
  display: flex;
  flex-direction: column;
}

.main-text {
  min-width: 0;
  max-width: 100%;
  margin: 0;
  align-self: center;
  padding: 8px;
  border-radius: 4px;
  color: #ffffff;
  background-color: #404753 !important;
}

.btn-container {
  display: flex;
  justify-content: flex-end;
  overflow: hidden;
  align-items: stretch;
  border-radius: 16px;
}
</style>
